import './users-are-saying.css';

import './img/star.svg';
import './img/facebook-icon.svg';
